module.exports = __webpack_public_path__ + "img/account.7e009f2a.svg";